import { render } from "./HelloWorld.vue?vue&type=template&id=e8466dae&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=e8466dae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8466dae"

export default script